import $ from 'jquery';

const toggleChildNav = () => {
    const $trigger = $('.sub-menu-toggle');

    if ($trigger.length === 0) return;

    $trigger.click(function () {
        $(this).toggleClass('active').next().slideToggle();
    });
};

// doc ready
$(() => {
    toggleChildNav();
});
